/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ViewConfig } from "./ViewConfig";
export const ViewUpdate = core.serialization.object({
    name: core.serialization.string().optional(),
    config: ViewConfig,
});
